<template>
  <v-container fluid class="px-8 d-flex flex-column">
    <div v-if="tripInfo" class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="d-flex flex-row align-end justify-space-between">
        <div>
          <div class="text-h4 font-weight-medium">{{ $t("navbar.menu.itinerary") }}</div>
          <div class="text-subtitle-1 primary--text">
            {{
              $t("itinerary.dates", {
                dates: `${$options.filters.zonedDate(tripInfo.start_date, "P", "UTC")} -
        ${$options.filters.zonedDate(tripInfo.end_date, "P", "UTC")}`,
              })
            }}
          </div>
        </div>
        <div style="width: 360px" v-if="!isSuperAdmin">
          <v-select
            v-model="subGroupFilters"
            :items="subgroups"
            dense
            color="primary"
            item-text="title"
            item-value="id"
            clearable
            rounded
            solo
            label="Filter"
          >
            <template v-slot:prepend-inner>
              <v-icon :color="subgroupColor(subGroupFilters)">mdi-account-group</v-icon>
            </template>
          </v-select>
        </div>
        <!-- <ItineraryMenu style="margin-right: 260px" /> -->
      </div>
    </div>
    <div class="flex-grow-1">
      <div class="d-flex flex-row">
        <v-card
          class="flex-grow-1 elevation-0"
          style="overflow-y: auto; max-height: calc(100vh - 180px)"
        >
          <v-card-text style="height: 100%; overflow-y: auto">
            <!-- <div class="d-flex flex-column" style="height: 100%"> -->
            <div v-if="activityDates.length === 0">
              No Activities, check your filters or create your first activity
            </div>
            <v-row align="start" no-gutters v-for="(date, index) in activityDates" :key="date">
              <v-col cols="12">
                <div
                  class="text-h6 my-2"
                  v-if="
                    index == 0 ||
                    !isSameMonth(
                      activityMap[activityDates[index - 1]][0].sortingDate,
                      activityMap[date][0].sortingDate,
                    )
                  "
                >
                  {{ uppercasedFormat(activityMap[date][0], "MMMM yyyy") }}
                </div>
              </v-col>
              <v-col cols="4" sm="3" md="2">
                <div class="d-flex flex-row align-center py-1">
                  <v-avatar :color="currentDay == date ? 'primary' : 'grey darken-2'" size="60">
                    <span class="text-h5 white--text">
                      {{
                        activityMap[date][0].sortingDate
                          | zonedDate("dd", activityMap[date][0].display_timezone)
                      }}
                    </span>
                  </v-avatar>
                  <div class="ml-2">
                    {{ uppercasedFormat(activityMap[date][0], "MMM, E") }}
                  </div>
                </div>
              </v-col>

              <v-col cols="8" sm="9" md="10">
                <v-card>
                  <v-card-text class="py-1">
                    <div v-for="activity in activityMap[date]" :key="activity.id">
                      <ActivityRow
                        :activity="activity"
                        :subgroups="subgroups"
                        :value="currentTooltip == activity.id"
                        @input="tooltipUpdated"
                        @edit="editActivity"
                        @delete="deleteActivity"
                        @clone="cloneActivity"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <ItineraryNavBar
          :subgroups="subgroups"
          :activityDates="activityDates"
          :isSuperAdmin="isSuperAdmin"
          v-model="subGroupFilters"
          :typeFilters="typeFilters"
          @typesChanged="typeFilters = $event"
        />
      </div>
    </div>
    <NewEvent
      :key="editEventKey"
      :editEvent="editEvent"
      :hotel="(editEvent || {}).hotel || false"
      :value="editEvent != null"
      @closed="
        editEvent = null;
        editEventKey++;
      "
      @remove="editEvent = null"
    />
    <NewTravel
      :key="editTravelKey"
      :editTravel="editTravel"
      :value="editTravel != null"
      @closed="
        editTravel = null;
        editTravelKey++;
      "
    />
    <ActivityCloner
      :forExport="forExport"
      v-if="cloningActivity"
      @saved="saveCloning"
      :activity="cloningActivity"
    />

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card v-if="deleteDialog">
        <v-card-title class="headline">Delete {{ deletingActivity.name }}</v-card-title>
        <v-card-text>{{ $t("common.notUndone") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              deleteDialog = false;
              deletingActivity = null;
            "
            >{{ $t("common.cancel") }}</v-btn
          >
          <v-btn color="error" @click="confirmDelete">{{ $t("common.delete") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import NewEvent from "@/components/CurrentTrip/Itinerary/NewEvent";
import NewTravel from "@/components/CurrentTrip/Itinerary/NewTravel";
import _ from "lodash";
import firestore from "@/firebase/firestore";
import colors from "@/assets/subgroup_colors.json";
import ActivityCloner from "@/components/CurrentTrip/Itinerary/ActivityCloner";
import ItineraryNavBar from "./components/ItineraryNavBar";
// import ItineraryMenu from "./components/ItineraryMenu";
import ActivityRow from "./components/ActivityRow";

export default {
  name: "Itinerary",
  components: {
    ItineraryNavBar,
    // ItineraryMenu,
    ActivityCloner,
    ActivityRow,
    NewEvent,
    NewTravel,
  },
  data() {
    return {
      subGroupFilters: [],
      typeFilters: [],
      editEventKey: 0,
      editTravelKey: 100,
      editTravel: null,
      editEvent: null,
      cloningActivity: null,
      forExport: false,
      exportDialog: false,
      deleteDialog: false,
      deletingActivity: null,
      currentTooltip: null,
      activityForReviews: null,
    };
  },
  watch: {
    isSuperAdmin(newVal) {
      console.log("watching isSuperAdmin");
      if (!newVal) {
        console.log("is super admin, filtering");
        const myId = this.$store.state.firUser.uid;
        const subgroup = this.subgroups.find((s) => s.users.includes(myId));
        console.log("setting subgroup to", subgroup);
        this.subGroupFilters = subgroup.id;
        console.log(this.subGroupFilters);
      }
    },
  },
  methods: {
    editActivity(activity) {
      if (activity.collection === "travels") {
        this.editTravel = activity;
      } else if (activity.collection === "events") {
        this.editEvent = activity;
      }
    },
    deleteActivity(activity) {
      // const { trip } = this.$store.state.trip;
      // firestore.deleteDocument(trip.id, "events", activity.id);
      this.deleteDialog = true;
      this.deletingActivity = activity;
    },
    cloneActivity({ activity, forExport }) {
      this.forExport = forExport;
      this.cloningActivity = activity;
      console.log(activity, forExport);
    },
    saveCloning(data) {
      if (data && this.cloningActivity) {
        data.dates.forEach((date) => {
          const newActivity = _.cloneDeep(this.cloningActivity);
          delete newActivity.id;
          delete newActivity.display_timezone;
          delete newActivity.ratings;
          delete newActivity.subgroups;
          delete newActivity.attendees;
          if (newActivity.location) {
            newActivity.location.date = date;
            data.tripIds.forEach((tripId) => {
              firestore.writeTrackedDocument(tripId, "events", newActivity);
            });
          } else {
            const offset =
              (newActivity.destin.date.seconds - newActivity.origin.date.seconds) * 1000;
            newActivity.origin.date = date;
            newActivity.destin.date = new Date(date.getTime() + offset);
            data.tripIds.forEach((tripId) => {
              firestore.writeTrackedDocument(tripId, "travels", newActivity);
            });
          }
        });
      }

      this.cloningActivity = null;
    },
    confirmDelete() {
      const { trip } = this.$store.state.trip;
      if (trip && this.deletingActivity) {
        const now = new Date();
        const collection = this.deletingActivity.location == null ? "travels" : "events";
        if (now > trip.start_date.toDate()) {
          console.log("trip has started, deleting properly");

          firestore.writeTrackedDocument(trip.id, collection, {}, this.deletingActivity.id, true);
        } else {
          console.log("trip has not started, deleting abruptly");
          firestore.deleteDocument(trip.id, collection, this.deletingActivity.id);
        }
        this.deleteDialog = false;
      }
    },
    tooltipUpdated(activityId) {
      console.log("tooltip has an event!!!");
      this.currentTooltip = activityId;
    },
    isSameMonth(date1, date2) {
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
    },
    uppercasedFormat(activity, strFormat) {
      return this.$options.filters
        .zonedDate(activity.sortingDate, strFormat, activity.display_timezone)
        .toUpperCase();
    },
    subgroupColor(subgroupId) {
      if (!subgroupId) return "gray";
      return (this.subgroups.find((s) => s.id === subgroupId) || { color: "gray" }).color;
    },
  },
  computed: {
    subgroups() {
      let nextColor = 0;
      console.log("updating subgroups");
      return this.tripSubgroups
        .map((subgroup) => ({
          id: subgroup.id,
          title: subgroup.name,
          users: Object.keys(subgroup.user_ids || {}),
          // eslint-disable-next-line no-plusplus
          color: subgroup.color || colors[nextColor++],
        }))
        .sort((a, b) => (a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1));
    },
    isSuperAdmin() {
      return true;
      // const myId = this.$store.state.firUser.uid;
      // return this.subgroups.filter((s) => s.users.includes(myId)).length !== 1;
    },
    filteredActivities() {
      console.log("filtering activities", this.typeFilters);
      if (
        this.typeFilters.length > 0 ||
        (this.subGroupFilters && this.subGroupFilters.length > 0)
      ) {
        return this.sortedItinerary.filter((activity) => {
          if (this.typeFilters.length > 0) {
            if (!this.typeFilters.includes("flight") && activity.collection === "flights") {
              return false;
            }

            if (
              !this.typeFilters.includes("hotel") &&
              activity.collection === "events" &&
              activity.hotel
            ) {
              return false;
            }

            if (
              !this.typeFilters.includes("virtual") &&
              activity.collection === "events" &&
              activity.remote_tz
            ) {
              return false;
            }
            if (
              !this.typeFilters.includes("destination") &&
              activity.collection === "events" &&
              !activity.remote_tz &&
              !activity.hotel
            ) {
              return false;
            }

            if (!this.typeFilters.includes("travel") && activity.collection === "travels") {
              return false;
            }
          }

          const isSubgroupInvited =
            this.subGroupFilters.length === 0 ||
            activity.privacy !== 3 ||
            Object.keys(activity.subgroups || {}).find(
              (as) =>
                // eslint-disable-next-line implicit-arrow-linebreak
                this.subGroupFilters.includes(as),
              // eslint-disable-next-line function-paren-newline
            );

          return isSubgroupInvited;
        });
      }
      return this.sortedItinerary;
    },
    currentDay() {
      return moment().format("YYYY-MM-DD");
    },
    activityMap() {
      console.log("recalculating activity map");
      return _.groupBy(this.filteredActivities, (activity) => {
        const dateMoment = moment(activity.sortingDate)
          .tz(activity.display_timezone || "UTC")
          .startOf("day");
        return dateMoment.format("YYYY-MM-DD");
      });
    },
    tripInfo() {
      return this.$store.state.trip.trip;
    },
    activityDates() {
      return Object.keys(this.activityMap).sort();
    },
    imageUrls() {
      return this.$store.state.imageUrls;
    },
    tripSubgroups() {
      return Object.values(this.$store.state.trip.subgroups || {});
    },
    ...mapGetters(["sortedItinerary"]),
  },
};
</script>
